import { render, staticRenderFns } from "./fgv-overview.vue?vue&type=template&id=c7d7ba92"
import script from "./fgv-overview.vue?vue&type=script&lang=ts"
export * from "./fgv-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports